import { Classification } from '@/features/classifications';
import { ClassificationFormInputs } from '@/features/classifications/types/classification-form-inputs';
import { artiaProtectedApi } from '@/lib/api-client';
import { deleteWithValidation, postWithValidation, putWithValidation } from '@/lib/api-helpers';

type ClassificationRequest = {
  name: string;
};

export const useClassificationService = () => {
  const getClassifications = (): Promise<Classification[]> => {
    return artiaProtectedApi.get('classifications');
  };

  const getClassification = (id: number): Promise<Classification> => {
    return artiaProtectedApi.get(`classifications/${id}`);
  };

  const createClassificationRequest = ({ name }: ClassificationFormInputs): ClassificationRequest => {
    return {
      name
    };
  };

  const createClassification = (formInputs: ClassificationFormInputs): Promise<any> => {
    return postWithValidation('classifications', { data: createClassificationRequest(formInputs) });
  };

  const updateClassification = (id: number | string, formInputs: ClassificationFormInputs): Promise<any> => {
    return putWithValidation(`classifications/${id}`, { data: createClassificationRequest(formInputs) });
  };

  const deleteClassification = (id: number | string): Promise<any> => {
    return deleteWithValidation(`classifications/${id}`);
  };

  return {
    getClassifications,
    getClassification,
    createClassification,
    updateClassification,
    deleteClassification
  };
};
